import { render, staticRenderFns } from "./wishInfoIndex.vue?vue&type=template&id=f6c54f00&scoped=true&"
import script from "./wishInfoIndex.vue?vue&type=script&lang=js&"
export * from "./wishInfoIndex.vue?vue&type=script&lang=js&"
import style0 from "./wishInfoIndex.vue?vue&type=style&index=0&id=f6c54f00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6c54f00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6c54f00')) {
      api.createRecord('f6c54f00', component.options)
    } else {
      api.reload('f6c54f00', component.options)
    }
    module.hot.accept("./wishInfoIndex.vue?vue&type=template&id=f6c54f00&scoped=true&", function () {
      api.rerender('f6c54f00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fude/wish/wishInfoIndex.vue"
export default component.exports